/* eslint-disable jsx-a11y/label-has-associated-control */
import TableWrapper from 'components/common/table-wrapper/TableWrapper'
import { alertTypes, initialMetaForTable } from 'constants/Common'
import React, { useEffect, useState } from 'react'
// import { useNavigate } from 'react-router-dom'
// import { PencilSimple, Trash } from 'phosphor-react'
import { getActionButtonProps } from 'utils/common'
import { useParams } from 'react-router-dom'
// import moment from 'moment'

import { toast } from 'react-toastify'
import CustomToast from 'components/common/custom-toast/CustomToast'
import {
  createAttendance,
  deleteAttendance,
  getAttendance,
  updateAttendance,
} from 'containers/attendance/Api'
import { get } from 'services/network'
// import { connect } from 'formik'
import AttendanceModal from './AttendanceModal'
import ConfirmationModal from './ConfirmationModal'

let timeout
const DEBOUNCE_DELAY = 700
function AttendanceListing() {
  //   const navigate = useNavigate()
  const { id: eventId } = useParams()
  const [attendanceList, setAttendanceList] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const [meta, setMeta] = React.useState(initialMetaForTable)
  const [isAttendanceModalVisible, setAttendanceModalVisible] =
    React.useState(false)
  const [refresh, setRefresh] = React.useState(false)
  const [selectedAttendance, setSelectedAttendance] = useState()
  const [
    isAttendanceConfirmationModalVisible,
    setAttendanceConfirmationModalVisible,
  ] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)

  const handleRefresh = () => {
    setRefresh((pre) => !pre)
  }
  const handleSetPerPage = (obj) => {
    setMeta((pre) => ({ ...pre, perPage: obj.value }))
    handleRefresh()
  }
  const debounceFn = (callback, delay) => {
    clearTimeout(timeout)
    timeout = setTimeout(callback, delay)
  }
  const handleSetSearchQuery = (value) => {
    setMeta((pre) => ({ ...pre, search: value }))
    debounceFn(handleRefresh, DEBOUNCE_DELAY)
  }
  const handlePageChange = (value) => {
    setMeta((pre) => ({ ...pre, page: value }))
    handleRefresh()
  }
  const handleCloseModal = () => {
    setAttendanceModalVisible(false)
    setSelectedAttendance()
  }
  const handleOpenModal = (item) => {
    setSelectedAttendance(item)
    setAttendanceModalVisible(true)
  }
  const fetchAttendance = async () => {
    // console.log(eventId)
    const result = await getAttendance(
      eventId,
      meta.page,
      meta.perPage,
      meta.search
    )
    if (result?.LastPage && result?.Total) {
      const resultMeta = result
      // console.log('resulk', resultMeta)
      setMeta((pre) => ({
        ...pre,
        totalCount: resultMeta.Total,
        totalPages: resultMeta.LastPage,
      }))
    }
    if (result?.attendees) {
      // const data = []
      // result.attendees.map((attendees) =>
      //   attendees.attended.map((item) =>
      //     data.push({
      //       name: attendees.user_name,
      //       email: attendees.user_email,
      //       date: item.date,
      //       visit_status: item.visit,
      //     })
      //   )
      // )

      setAttendanceList(result?.attendees)
    }
    setLoading(false)
  }

  const handleCreateAttendance = async (values) => {
    const updatedValues = { ...values, status: 'pending' }
    const result = await createAttendance(updatedValues)
    if (result?.status === 200) {
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={result?.statusText || 'Attendance Created Successfully!'}
        />
      )
      handleRefresh()
      handleCloseModal()
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error}
        />
      )
    }
  }

  const handleUpdateAttendance = async (payload) => {
    /* eslint no-underscore-dangle: 0 */
    const id = payload._id
    const updatedValues = { ...payload, status: 'pending' }
    const result = await updateAttendance(updatedValues, id)
    if (result?.status === 200) {
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={result?.statusText || 'Attendance Updated Successfully!'}
        />
      )
      handleCloseModal()
      handleRefresh()
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error}
        />
      )
    }
  }

  const downloadExcel = async (event) => {
    try {
      const response = await get(
        `${process.env.REACT_APP_API_URL}event/export/${event}`,
        true,
        null,
        null,
        {
          responseType: 'blob',
          headers: {
            Accept: 'text/csv',
          },
        }
      )

      const link = document.createElement('a')
      link.href = URL.createObjectURL(response)
      link.download = event.name || 'Export'
      link.click()
      return true
    } catch (error) {
      return error
    }
  }

  const handleCloseAttendanceConfirmationModal = () => {
    setAttendanceConfirmationModalVisible(false)
    setSelectedAttendance()
    setIsDeleting(false)
  }
  // const handleOpenAttendanceConfirmationModal = () => {
  //   setAttendanceConfirmationModalVisible(true)
  // }
  const handleDeleteAttendance = async () => {
    // eslint-disable-next-line no-underscore-dangle
    const result = await deleteAttendance(selectedAttendance._id)
    if (result?.status === 200) {
      toast(
        <CustomToast
          variant={alertTypes.SUCCESS}
          message={result?.statusText || 'Attendance Deleted Successfully!'}
        />
      )
      handleRefresh()
      handleCloseAttendanceConfirmationModal()
    } else {
      toast(
        <CustomToast
          variant={alertTypes.DANGER}
          message={result?.response?.data?.error}
        />
      )
    }
  }
  const handleConfirmAttendance = () => {}

  useEffect(() => {
    fetchAttendance()
  }, [refresh])

  useEffect(() => {
    console.log('attendeesList', attendanceList)
  }, [attendanceList])

  return (
    <div className='user-main'>
      <div className='container-fluid'>
        <TableWrapper
          setPerPage={handleSetPerPage}
          setSearchQuery={handleSetSearchQuery}
          searchValue={meta.search}
          totalListCount={meta.totalCount}
          pageSize={meta.perPage}
          currentPage={meta.page}
          onPageChange={handlePageChange}
          actionButtons={[
            ...getActionButtonProps('Export', () => {
              // onClick={() => {
              downloadExcel(eventId)
              // }}
            }),
          ]}
        >
          {loading ? (
            <p style={{ textAlign: 'center' }}>Loading</p>
          ) : (
            <table className='table table-main'>
              <thead>
                <tr>
                  <th scope='col'>
                    <div className='header-text-otr'>
                      <p
                        className='table-name heading-xsb'
                        aria-label='User index Column'
                      >
                        #
                      </p>
                    </div>
                  </th>
                  <th scope='col'>
                    <div className='header-text-otr'>
                      <p
                        className='table-name heading-xsb'
                        aria-label='User Name Column'
                      >
                        Name
                      </p>
                    </div>
                  </th>
                  <th scope='col'>
                    <div className='header-text-otr'>
                      <p
                        className='table-name heading-xsb'
                        aria-label='User Name Column'
                      >
                        Email
                      </p>
                    </div>
                  </th>
                  {/* <th scope='col'>
                    <div className='header-text-otr'>
                      <p
                        className='table-name heading-xsb'
                        aria-label='User Name Column'
                      >
                        Date
                      </p>
                    </div>
                  </th> */}
                  <th scope='col'>
                    <div className='header-text-otr'>
                      <p
                        className='table-name heading-xsb'
                        aria-label='User Name Column'
                      >
                        Visit Details
                      </p>
                    </div>
                  </th>

                  {/* <th scope='col' className='action-column'>
                    <div className='header-text-otr'>
                      <p
                        className='table-name heading-xsb'
                        aria-label='User Action Name Column'
                      >
                        Actions
                      </p>
                    </div>
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {attendanceList?.map((item, index) => (
                  <tr key={item.id}>
                    <th scope='col'>
                      <div className='header-text-otr'>
                        <p
                          className='table-name heading-xsb'
                          aria-label='User Table Data Column'
                        >
                          {index + 1}
                        </p>
                      </div>
                    </th>
                    <td>
                      <div className='table-text-otr'>
                        <p className='table-text-black' title={item.name}>
                          {item.user_name ?? 'N/A'}
                        </p>
                      </div>
                    </td>

                    <td>
                      <div className='table-text-otr'>
                        <p className='table-text-black' title={item.email}>
                          {item.user_email ?? 'N/A'}
                        </p>
                      </div>
                    </td>

                    {/* <td>
                      <div className='table-text-otr'>
                        <p className='table-text-black' title={item.dateTime}>
                          {item.date
                            ? moment(item.date).format(
                                'MMMM Do YYYY, h:mm:ss a'
                              )
                            : 'N/A'}
                        </p>
                      </div>
                    </td> */}

                    <td>
                      <div className='table-text-otr'>
                        <p
                          className='table-text-black'
                          // title={item.visit_status}
                        >
                          <button
                            type='button'
                            className='primary-btn rounded record-btn'
                            onClick={() => handleOpenModal(item.attended)}
                          >
                            Details
                          </button>
                        </p>
                      </div>
                    </td>
                    {/* <td>
                      <div className='table-text-otr'>
                        <p
                          className='table-text-black'
                          title={item.visit_status}
                        >
                          {item.visit_status === false
                            ? 'Not attended'
                            : 'Attended'}
                        </p>
                      </div>
                    </td> */}

                    {/* <td className='action-column'>
                      <div className='table-icon-otr'>
                        {moment().isAfter(moment(item.dateTime)) && (
                          <div
                            className='icon-otr'
                            role='button'
                            tabIndex={0}
                            aria-label='Edit Attendance'
                          >
                            <PencilSimple
                              className='primary-color'
                              size={18}
                              onClick={() => {
                                setSelectedAttendance(item)
                                handleOpenModal()
                              }}
                            />
                          </div>
                        )}
                        <div
                          className='icon-otr'
                          role='button'
                          tabIndex={0}
                          aria-label='Delete Attendance'
                        >
                          <Trash
                            className='danger-color'
                            size={18}
                            onClick={() => {
                              setIsDeleting(true)
                              setSelectedAttendance(item)
                              handleOpenAttendanceConfirmationModal()
                            }}
                          />
                        </div>
                      </div>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </TableWrapper>
      </div>
      {isAttendanceConfirmationModalVisible && (
        <ConfirmationModal
          handleConfirmAttendance={
            isDeleting ? handleDeleteAttendance : handleConfirmAttendance
          }
          handleCloseModal={handleCloseAttendanceConfirmationModal}
          isDeleting={isDeleting}
          selectedAttendance={selectedAttendance}
        />
      )}
      {isAttendanceModalVisible && (
        <AttendanceModal
          handleCloseModal={handleCloseModal}
          selectedAttendance={selectedAttendance}
          handleSaveAttendance={handleCreateAttendance}
          handleUpdateAttendance={handleUpdateAttendance}
        />
      )}
    </div>
  )
}

export default AttendanceListing
